import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLogin } from '../src/Utils/Index';

const PublicRoute = ({component: Component, restricted, ...rest}) => {
    return (
        <Route {...rest} render={props => (
            isLogin() && restricted ?
                <Redirect to="/" />
            : <Component {...props} />
        )} />
    );
};

export default PublicRoute